export class AdUpdateRequest {
    newAdImageId: string;
    adId: number;
    runDate: Date;
    endDate: Date;
}